import {GetterTree} from "vuex";

const getters: GetterTree<IssueTrackerState, RootState> = {

};

export default getters;
